const FETCHING_DASHBOARD_DATA_ERROR = "@dashboard/fetchingDashboardDataError";
const FETCHING_DASHBOARD_DATA_SUCCESS = "@dashboard/fetchingDashboardDataSuccess";
const FETCH_DASHBOARD_DATA = "@dashboard/fetchDashboardData";

const FETCHING_INVOICE_TYPES_ERROR = "@dashboard/fetchingInvoiceTypesError";
const FETCHING_INVOICE_TYPES_SUCCESS = "@dashboard/fetchingInvoiceTypesSuccess";
const FETCH_INVOICE_TYPES = "@dashboard/fetchInvoiceTypes";

const CLEAR_STORE = "@dashboard/clearStore";
const CHANGE_DATE_RANGE = "@dashboard/changeDateRange";

const SET_TYPE = "@dashboard/setType";

export {
  FETCH_DASHBOARD_DATA,
  FETCHING_DASHBOARD_DATA_ERROR,
  FETCHING_DASHBOARD_DATA_SUCCESS,
  CLEAR_STORE,
  CHANGE_DATE_RANGE,
  SET_TYPE,
  FETCH_INVOICE_TYPES,
  FETCHING_INVOICE_TYPES_SUCCESS,
  FETCHING_INVOICE_TYPES_ERROR
};
